import { InjectorService } from '@tencent/ioc';
import { ControllerRegistry } from '../../registries/controller-registry.js';

/**
 * Controller 装饰器，用于声明一个新的 UI 控制器
 *
 * @param options - Controller 配置
 * @param shouldActive - 判断是否应该启用 Controller 的方法
 * @decorator
 * @public
 */
function Controller(options = {}, shouldActive = () => true) {
    return (target) => {
        target.prototype.toString = () => { var _a; return (_a = options.name) !== null && _a !== void 0 ? _a : target.name; };
        target.displayName = options.name;
        if (shouldActive()) {
            ControllerRegistry.merge(target, options);
        }
        /* 需要设置overridable为true,因为品类代码里存在如下用法,该用法会用新controller实例替换原有实例
         ```
            Controller({ menuItems })(AddonNewController);
            this.controllerService.buildController(AddonNewController);
        ```
        */
        InjectorService.service(target, { type: 'controller', overridable: true });
        InjectorService.invokable(target);
    };
}

export { Controller };
//# sourceMappingURL=controller.js.map
